import { render, staticRenderFns } from "./service-template-selection-modal.vue?vue&type=template&id=621c4ca9&scoped=true"
import script from "./service-template-selection-modal.vue?vue&type=script&lang=js"
export * from "./service-template-selection-modal.vue?vue&type=script&lang=js"
import style0 from "./service-template-selection-modal.vue?vue&type=style&index=0&id=621c4ca9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621c4ca9",
  null
  
)

export default component.exports